import { render, staticRenderFns } from "./addWhatsappApp.vue?vue&type=template&id=6a1e606c&scoped=true"
import script from "./addWhatsappApp.vue?vue&type=script&lang=js"
export * from "./addWhatsappApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e606c",
  null
  
)

export default component.exports